module.exports = __webpack_public_path__ + "assets/img/0204.934d49ed.svg";